module.exports = __webpack_public_path__ + "img/icon-home-phone.69b97d86.svg";